module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--2--redeem-5d7c4eb3.png";